function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTdBank = function SvgTdBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57b14c"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 29.8h-8.9V14h4.4v13H26c3 0 4.2-2.1 4.2-7.2 0-5.3-1.4-6.8-4.4-6.8H16v16.9h-4.4V13H5v-2.8h22.1c5.4 0 7.9 2.7 7.9 9.5 0 9.1-3.8 10.1-8.9 10.1",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgTdBank;